import {get} from 'api/http'

export function fetch(locale) {
    return get('locale/get', {locale})
}

export function fetchList() {
    return get('locale/list')
}